var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBarChartGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00044 3.16663C8.58711 3.16663 9.06711 3.64663 9.06711 4.23329V12.7666C9.06711 13.3533 8.58711 13.8333 8.00044 13.8333C7.41377 13.8333 6.93377 13.3533 6.93377 12.7666V4.23329C6.93377 3.64663 7.41377 3.16663 8.00044 3.16663ZM3.73366 6.36663H3.88604C4.47271 6.36663 4.95271 6.84663 4.95271 7.43329V12.7666C4.95271 13.3533 4.47271 13.8333 3.88604 13.8333H3.73366C3.14699 13.8333 2.66699 13.3533 2.66699 12.7666V7.43329C2.66699 6.84663 3.14699 6.36663 3.73366 6.36663ZM13.3336 10.3285C13.3336 9.74186 12.8536 9.26186 12.2669 9.26186C11.6803 9.26186 11.2003 9.74186 11.2003 10.3285V12.7666C11.2003 13.3533 11.6803 13.8333 12.2669 13.8333C12.8536 13.8333 13.3336 13.3533 13.3336 12.7666V10.3285Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartGray);
export default __webpack_public_path__ + "static/media/BarChartGray.b5f665f44e142f039ec29806c0ed2317.svg";
export { ForwardRef as ReactComponent };